module.exports = __webpack_public_path__ + "RokuEnTitle.png";